/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.user
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_user_customer_pb = require('../../../../io/codedrills/proto/user/customer_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.user = require('./customer_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.CustomerServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ListCustomersRequest,
 *   !proto.io.codedrills.proto.user.ListCustomersResponse>}
 */
const methodInfo_CustomerService_ListCustomers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ListCustomersResponse,
  /** @param {!proto.io.codedrills.proto.user.ListCustomersRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ListCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.listCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ListCustomers',
      request,
      metadata || {},
      methodInfo_CustomerService_ListCustomers,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ListCustomersResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.listCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ListCustomers',
      request,
      metadata || {},
      methodInfo_CustomerService_ListCustomers);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.SignUpCustomerRequest,
 *   !proto.io.codedrills.proto.user.SignUpCustomerResponse>}
 */
const methodInfo_CustomerService_SignUpCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.SignUpCustomerResponse,
  /** @param {!proto.io.codedrills.proto.user.SignUpCustomerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.SignUpCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.SignUpCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.SignUpCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.SignUpCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.signUpCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/SignUpCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_SignUpCustomer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.SignUpCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.SignUpCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.signUpCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/SignUpCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_SignUpCustomer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetCustomerRequest,
 *   !proto.io.codedrills.proto.user.GetCustomerResponse>}
 */
const methodInfo_CustomerService_GetCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetCustomerResponse,
  /** @param {!proto.io.codedrills.proto.user.GetCustomerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_GetCustomer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateCustomerRequest,
 *   !proto.io.codedrills.proto.user.UpdateCustomerResponse>}
 */
const methodInfo_CustomerService_UpdateCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateCustomerResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateCustomerRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.updateCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateCustomer,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.updateCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateCustomer',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateCustomer);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.InviteAdminRequest,
 *   !proto.io.codedrills.proto.user.InviteAdminResponse>}
 */
const methodInfo_CustomerService_InviteAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.InviteAdminResponse,
  /** @param {!proto.io.codedrills.proto.user.InviteAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.InviteAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.InviteAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.InviteAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.InviteAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.inviteAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/InviteAdmin',
      request,
      metadata || {},
      methodInfo_CustomerService_InviteAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.InviteAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.InviteAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.inviteAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/InviteAdmin',
      request,
      metadata || {},
      methodInfo_CustomerService_InviteAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ListAdminsRequest,
 *   !proto.io.codedrills.proto.user.ListAdminsResponse>}
 */
const methodInfo_CustomerService_ListAdmins = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ListAdminsResponse,
  /** @param {!proto.io.codedrills.proto.user.ListAdminsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ListAdminsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ListAdminsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ListAdminsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ListAdminsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.listAdmins =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ListAdmins',
      request,
      metadata || {},
      methodInfo_CustomerService_ListAdmins,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ListAdminsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ListAdminsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.listAdmins =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ListAdmins',
      request,
      metadata || {},
      methodInfo_CustomerService_ListAdmins);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.DeleteAdminRequest,
 *   !proto.io.codedrills.proto.user.DeleteAdminResponse>}
 */
const methodInfo_CustomerService_DeleteAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.DeleteAdminResponse,
  /** @param {!proto.io.codedrills.proto.user.DeleteAdminRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.DeleteAdminResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.DeleteAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.DeleteAdminResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.DeleteAdminResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.deleteAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/DeleteAdmin',
      request,
      metadata || {},
      methodInfo_CustomerService_DeleteAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.DeleteAdminRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.DeleteAdminResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.deleteAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/DeleteAdmin',
      request,
      metadata || {},
      methodInfo_CustomerService_DeleteAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.ManagePaymentRequest,
 *   !proto.io.codedrills.proto.user.ManagePaymentResponse>}
 */
const methodInfo_CustomerService_ManagePayment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.ManagePaymentResponse,
  /** @param {!proto.io.codedrills.proto.user.ManagePaymentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.ManagePaymentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.ManagePaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.ManagePaymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.ManagePaymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.managePayment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ManagePayment',
      request,
      metadata || {},
      methodInfo_CustomerService_ManagePayment,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.ManagePaymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.ManagePaymentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.managePayment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/ManagePayment',
      request,
      metadata || {},
      methodInfo_CustomerService_ManagePayment);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.CheckoutRequest,
 *   !proto.io.codedrills.proto.user.CheckoutResponse>}
 */
const methodInfo_CustomerService_Checkout = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.CheckoutResponse,
  /** @param {!proto.io.codedrills.proto.user.CheckoutRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.CheckoutResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.CheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.CheckoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.CheckoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.checkout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/Checkout',
      request,
      metadata || {},
      methodInfo_CustomerService_Checkout,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.CheckoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.CheckoutResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.checkout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/Checkout',
      request,
      metadata || {},
      methodInfo_CustomerService_Checkout);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetRecruiterProfileRequest,
 *   !proto.io.codedrills.proto.user.GetRecruiterProfileResponse>}
 */
const methodInfo_CustomerService_GetRecruiterProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetRecruiterProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.GetRecruiterProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetRecruiterProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetRecruiterProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetRecruiterProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetRecruiterProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.getRecruiterProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetRecruiterProfile',
      request,
      metadata || {},
      methodInfo_CustomerService_GetRecruiterProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetRecruiterProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetRecruiterProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.getRecruiterProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetRecruiterProfile',
      request,
      metadata || {},
      methodInfo_CustomerService_GetRecruiterProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateRecruiterProfileRequest,
 *   !proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse>}
 */
const methodInfo_CustomerService_UpdateRecruiterProfile = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateRecruiterProfileRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateRecruiterProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.updateRecruiterProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateRecruiterProfile',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateRecruiterProfile,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateRecruiterProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateRecruiterProfileResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.updateRecruiterProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateRecruiterProfile',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateRecruiterProfile);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.GetCustomerHiringPlanRequest,
 *   !proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse>}
 */
const methodInfo_CustomerService_GetCustomerHiringPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse,
  /** @param {!proto.io.codedrills.proto.user.GetCustomerHiringPlanRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerHiringPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.getCustomerHiringPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetCustomerHiringPlan',
      request,
      metadata || {},
      methodInfo_CustomerService_GetCustomerHiringPlan,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.GetCustomerHiringPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.GetCustomerHiringPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.getCustomerHiringPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/GetCustomerHiringPlan',
      request,
      metadata || {},
      methodInfo_CustomerService_GetCustomerHiringPlan);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.user.UpdateCustomerPlanRequest,
 *   !proto.io.codedrills.proto.user.UpdateCustomerPlanResponse>}
 */
const methodInfo_CustomerService_UpdateCustomerPlan = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.user.UpdateCustomerPlanResponse,
  /** @param {!proto.io.codedrills.proto.user.UpdateCustomerPlanRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.user.UpdateCustomerPlanResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCustomerPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.user.UpdateCustomerPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.user.UpdateCustomerPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.user.CustomerServiceClient.prototype.updateCustomerPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateCustomerPlan',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateCustomerPlan,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.user.UpdateCustomerPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.user.UpdateCustomerPlanResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.user.CustomerServicePromiseClient.prototype.updateCustomerPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.user.CustomerService/UpdateCustomerPlan',
      request,
      metadata || {},
      methodInfo_CustomerService_UpdateCustomerPlan);
};


module.exports = proto.io.codedrills.proto.user;

